import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { CommonService } from '../common/services/common.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserAccountService {

  bookingDetailObject = new BehaviorSubject<any>({});
  constructor(private _commonService: CommonService, private _http: HttpClient) { }

  getUserDetails(userId) {
    return(this._http.get(this._commonService.baseUrl + 'user/get/' + userId));
  }

  setBookingDetail(ob){
    this.bookingDetailObject.next(ob);
  }

  // getBookings(userId) {
  //   return(this._http.get(this._commonService.baseUrl + 'user/getbookings/' + userId));
  // }

  // getCredits(userId) {
  //   return(this._http.get(this._commonService.baseUrl + 'user/getcredits/' + userId));
  // }

  updateUserDetails(params) {
    return(this._http.post(this._commonService.baseUrl + 'user/update', params));
  }

  changePassword(params) {
    return(this._http.post(this._commonService.baseUrl + 'user/changepassword', params));
  }


  getBookings(Emailid:string){
    var rq = {
      "Email": Emailid
    } 
    return(this._http.post(this._commonService.baseUrl + 'user/getbookings', rq));
  }

  getBookingDetail(bookId:any){
   var rq = {
     "id":bookId
   }
   console.log(rq);
    return(this._http.post(this._commonService.baseUrl + 'user/getbookingDetail', rq));
  }

  getCredits(Emailid:string){
    var rq = {
      "Email": Emailid
    } 
      return(this._http.post(this._commonService.baseUrl + 'user/getcredits', rq));
  }

  sendTicket(params) {
    return(this._http.post(this._commonService.baseUrl + 'sendticket', params));
  }

}
